import React from 'react'
import { TooltipRenderProps } from 'react-joyride'
import FeedbackStepTooltip from './FeedbackStepTooltip'
import StandardStepTooltip from './StandardStepTooltip'
import {
  TutorialStep as ImportedTutorialStep,
  ExtendedHelpers as ImportedExtendedHelpers,
} from '../../../tour/types'

interface JoyrideTooltipRendererProps extends TooltipRenderProps {
  pageContext?: 'patternBuilder' | 'backtest' | 'alerts'
  usermeta: any
  tradingHouse: any
  allOriginalStepsForMenu: readonly ImportedTutorialStep[]
  compatibleJoyrideHelpers: ImportedExtendedHelpers | null
  jumpTargetRefFromController: React.MutableRefObject<number | null>
  setRunController: (run: boolean) => void
  setStepIndexController: (index: number) => void
  onCompleteController?: () => void
}

const JoyrideTooltipRenderer: React.FC<JoyrideTooltipRendererProps> = (props) => {
  const {
    step,
    pageContext,
    usermeta,
    tradingHouse,
    allOriginalStepsForMenu,
    compatibleJoyrideHelpers,
    jumpTargetRefFromController,
    setRunController,
    setStepIndexController,
    onCompleteController,
  } = props

  const currentStepData = step as ImportedTutorialStep

  const handleFeedbackSubmitAndProceed = (isLastStep: boolean) => {
    if (isLastStep) {
      setRunController(false)
      setStepIndexController(0)
      onCompleteController?.()
    } else {
      compatibleJoyrideHelpers?.next()
    }
  }

  if ((currentStepData as any).isFeedback) {
    return (
      <FeedbackStepTooltip
        {...props}
        pageContext={pageContext}
        usermeta={usermeta}
        tradingHouse={tradingHouse}
        onFeedbackSubmitAndProceed={handleFeedbackSubmitAndProceed}
      />
    )
  }

  return (
    <StandardStepTooltip
      {...props}
      allOriginalSteps={allOriginalStepsForMenu}
      compatibleJoyrideHelpers={compatibleJoyrideHelpers}
      jumpTargetRefFromController={jumpTargetRefFromController}
      setStepIndexFromController={setStepIndexController}
    />
  )
}

export default JoyrideTooltipRenderer
